import { createComponent } from '@carvana/merch-components';

export const Bar = createComponent('span', {
  className: 'h-16 border-0 border-l border-border-weak'
});
